import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function LeaderboardCard() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("leaderboardCard.title")}</h1>
      <p>{t("leaderboardCard.intro")}</p>

      <CodeBlock title="leaderboardImage()">{`import { leaderboardImage } from "kira-arts";

const buffer = await leaderboardImage(
  [
    { userId: "111", currentXp: 900, requiredXp: 1000, level: 14, rank: 1 },
    { userId: "222", currentXp: 340, requiredXp: 500, level: 8, rank: 2 },
  ],
  { guildId, useRoleColor: true, title: "Weekly top", maxEntries: 10 },
);`}</CodeBlock>

      <h2>{t("leaderboardCard.optionsTitle")}</h2>
      <CodeBlock title="LeaderboardOptions">{`title?: string;
subtitle?: string;
accentColor?: string;
barColor?: ColorInput;
levelColor?: string;
usernameColor?: string;
borderColor?: ColorInput;
removeBorder?: boolean;
useNitroTheme?: boolean;
useRoleColor?: boolean;
backgroundImage?: string;
maxEntries?: number;
guildId?: string;
theme?: KiraThemeName;`}</CodeBlock>

      <p>
        <Trans
          i18nKey="leaderboardCard.fieldNameNote"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <p>
        <Trans
          i18nKey="leaderboardCard.sortNote"
          components={[<strong key="0" />, <code key="1" />]}
        />
      </p>
    </article>
  );
}
